import React from "react";
import { useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import TermTextInput from "./inputs/TermTextInput";
import TermURLInput from "./inputs/TermURLInput";
import TermClassInput from "./TermClassInput";
import type { FormLabelType } from "src/shared/forms/formrenderers/FormLabelRenderer";
import EmptyTooltip from "src/shared/forms/tooltips/EmptyTooltip";
import type TermClassType from "src/shared/term/objects/TermClassType";
import type TermTemplate from "src/shared/term/objects/TermTemplate";

export const TERM_CLASS = "termClass";
export const TERM_URL = "termUrl";
export const TERM_TEXT = "termText";

export interface ITermFormProps {
  form: string;
  inputID: string;
  termTemplates: TermTemplate[];
  label: FormLabelType;
  urlLabel: FormLabelType;
  textLabel: FormLabelType;
}

export default (props: ITermFormProps) => {
  const { inputID, termTemplates, label, urlLabel, textLabel } = props;

  const selector = formValueSelector(props.form);
  const termClass: TermClassType | undefined = useSelector(
    (state) => selector(state, inputID)[TERM_CLASS],
  );

  if (!termTemplates.length) {
    return null;
  }

  return (
    <>
      <TermClassInput
        inputID={`${inputID}[${TERM_CLASS}`}
        label={label}
        termTemplates={termTemplates}
        tooltip={<EmptyTooltip />}
      />

      {termClass === "URL" && (
        <TermURLInput inputID={`${inputID}[${TERM_URL}`} label={urlLabel} />
      )}

      {termClass === "TEXT" && (
        <TermTextInput
          inputID={`${inputID}[${TERM_TEXT}`}
          label={textLabel}
          tooltip={<EmptyTooltip />}
        />
      )}
    </>
  );
};
